import React from "react";
import { RefreshCw, Lock, AlertTriangle } from "lucide-react";

/** Shared card shell for every Monthly Record section - guarantees each one independently
 * handles loading/permission-denied/error/empty/success without duplicating that logic
 * across ~10 sections (Schedule, Availability, Timecard, Reconciliation, Payroll, ...). */
export const SectionFrame = ({ title, icon: Icon, testId, loading, error, onRetry, isEmpty, emptyMessage, children }) => {
  return (
    <div id={testId} className="bg-white rounded-xl border border-slate-200 p-5" data-testid={testId}>
      <div className="flex items-center gap-2 mb-4">
        {Icon && <Icon size={16} className="text-slate-500" />}
        <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide">{title}</p>
      </div>

      {loading && (
        <p className="text-sm text-slate-400" data-testid={`${testId}-loading`}>Loading...</p>
      )}

      {!loading && error && error.status === 403 && (
        <div className="flex items-center gap-2 text-sm text-slate-500" data-testid={`${testId}-permission-denied`}>
          <Lock size={14} /> You do not have permission to view this section.
        </div>
      )}

      {!loading && error && error.status !== 403 && (
        <div className="flex items-center justify-between gap-3" data-testid={`${testId}-error`}>
          <span className="flex items-center gap-2 text-sm text-red-600"><AlertTriangle size={14} /> {error.message}</span>
          <button
            data-testid={`${testId}-retry-button`}
            onClick={onRetry}
            className="flex items-center gap-1 px-3 py-1.5 rounded-full border border-slate-300 text-xs font-semibold text-slate-600 hover:bg-slate-50"
          >
            <RefreshCw size={12} /> Retry
          </button>
        </div>
      )}

      {!loading && !error && isEmpty && (
        <p className="text-sm text-slate-500" data-testid={`${testId}-empty`}>{emptyMessage}</p>
      )}

      {!loading && !error && !isEmpty && children}
    </div>
  );
};
